import React from "react";
import { DropDownInfo } from "../../domain/info";
import { FilterSetters } from "./elsearch.domain";
import { DataSourceFilter } from "../../interfaces/ElasticSearchInterface";
import { useAllSearchData, immediateSearch, useSearchResultsFromAllSearchData } from "@me8eon/search";
import { SearchDropdown } from "@me8eon/search_dropdown"
import { EnvironmentConfig } from "@me8eon/config";
import { useSelectedDataViewName } from "@me8eon/data_view_filter";

export type SearchInputProps = {
    onChange: (searchTerm: string) => void
    onSubmit: (searchTerm: string) => void
};

export function SearchInput({ onSubmit }: Readonly<SearchInputProps>) {
    const [allSearch] = useAllSearchData();
    const [selectedOps] = useSelectedDataViewName();
    // const listData = allSearch.immediate.searchResults.elasticSearch?.value?.results;
    const listData = useSearchResultsFromAllSearchData(immediateSearch)

    return (
        <>
            <SearchDropdown
                onSubmit={onSubmit}
                // dataToDisplay={selectedOps !== "all" && EnvironmentConfig.isHigherEnv ? [] : listData}
                dataToDisplay={listData}
                maxHeight="280px"
            />
        </>
    );
}

export type DataType =
    | ""
    | "all"
    | "apps"
    | "allWithFilter"
    | "m365"
    | "jql"
    | "people"
    | "assistance";

export type SelectDataTypeProps = {
    options: DropDownInfo[];
    dataType: string;
    setters: FilterSetters;
    dataSourceFilters: DataSourceFilter[];
};
